export default __webpack_public_path__ + "static/media/conveni_L.8c9ce913.jpg";